export type {
  YardSpotAssignmentDetails,
  YardSpotDetails,
  YardSpotReserveDetails
} from './yardSpotPresenterV2Shared';

export { useYardSpotFetcherV2 } from './useYardSpotFetcherV2';
export type { UseYardSpotFetcherV2Options } from './useYardSpotFetcherV2';
export type { UseYardSpotFetcherV2Options as UseYardSpotPresenterV2Options } from './useYardSpotFetcherV2';

export { useYardSpotDisplayV2 } from './useYardSpotDisplayV2';
export type {
  YardSpotDisplayField,
  YardSpotDisplayV2Data,
  UseYardSpotDisplayV2Options
} from './useYardSpotDisplayV2';

import { useYardSpotFetcherV2 } from './useYardSpotFetcherV2';

import type { UseYardSpotFetcherV2Options } from './useYardSpotFetcherV2';

/**
 * Combined fetch + live-update composable. Delegates to {@link useYardSpotFetcherV2}.
 * Pair with {@link useYardSpotDisplayV2} when fetch is owned by a parent (e.g. list row).
 */
export function useYardSpotPresenterV2(options: UseYardSpotFetcherV2Options) {
  return useYardSpotFetcherV2(options);
}
